import React from "react";
import { Chip } from '@material-ui/core';
import clsx from "clsx";

export default ({ label, data, classes, style, labelStyle, rowStyle }) => {
  return (
    <div className={classes.muDetailWrap} style={rowStyle}>
      <div title={label} className={classes.muLabels} style={labelStyle}>
        {label}
      </div>
      <div className={classes.muSeperator}>:</div> 
      <div className={clsx(classes.muDetails, classes.muTags)} style={style} title={data && data.length > 0 && Array.isArray(data) ? data.join(", "): ""}>
        {
          (data && data.length > 0 && Array.isArray(data)) ? data.map(item => <Chip label={item} />) : null
        }
      </div>
    </div>
  );
};
